module.exports = __webpack_public_path__ + "static/media/corporate-catering-2.241745a0.jpg";